<template>
  <div style="width: 100%; height: 100%" ref="mychart"></div>
</template>
<script>
import * as echarts from 'echarts'
export default {
  name: 'ChartsBarPie',
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    data() {
      this.initMyChart() // 重置图表
    }
  },
  mounted() {
    // this.initMyChart()
    setTimeout(() => {
      this.initMyChart()
      const resizeOb = new ResizeObserver((entries) => {
        for (const entry of entries) {
          echarts.getInstanceByDom(entry.target).resize()
        }
      })
      resizeOb.observe(this.$refs.mychart)
    })
  },
  methods: {
    initMyChart() {
      // 基于准备好的dom，初始化echarts实例
      let mychart = echarts.getInstanceByDom(this.$refs.mychart)
      if (mychart == null) mychart = echarts.init(this.$refs.mychart)
      var colors = ['#667eea', '#19be6b']
      let xAxisData = []
      let seriesData = []
      let seriesList = []
      console.log(this.data)
      if (this.data) {
        xAxisData = this.data.map((el) => {
          return el.quarter + '季度'
        })
        let datas = Object.values(this.data)
        seriesData = datas.map((itm) => {
          return itm.aveScore
        })
        seriesList = datas.map((itm) => {
          return itm.dangerous
        })
      }
      let option = {
        // 标题
        title: {
          text: this.title,
          left: 'center',
          top: 15,
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal'
          }
        },
        // 工具提示
        tooltip: {
          trigger: 'axis',
          // formatter: '{b} <br/>{a} : {c}',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '6%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: xAxisData,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '安全分值',
            position: 'left',
            minInterval: 1, //设置成1保证坐标轴分割刻度显示成整数

            axisLine: {
              show: true,
              lineStyle: {
                color: colors[0]
              }
            },
            min: (value) => {
              // return value.min
              return Math.floor(value.min / 10) * 10
            },
            max: (value) => {
              return Math.ceil(value.max)
              // return Math.ceil(value.max / 100) * 100
            }
          },
          {
            type: 'value',
            name: `危\n险\n设\n备\n占\n比`,
            // offset: 20,
            position: 'right',
            minInterval: 1, //设置成1保证坐标轴分割刻度显示成整数

            // 位置
            nameLocation: 'middle',
            // 坐标轴名称与轴线距离
            nameGap: 38,
            // 坐标轴名称旋转
            nameRotate: 360,
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[1]
              }
            },
            min: (value) => {
              // return value.min
              return Math.floor(value.min / 10) * 10
            },
            max: (value) => {
              return Math.ceil(value.max)
              // return Math.ceil(value.max / 100) * 100
            },
            axisLabel: {
              // color: '#65a8fe',
              formatter: '{value} %'
            }
          }
        ],
        // 颜色配置
        color: colors,
        //让两条柱状合在一起
        // barGap: '-100%',
        // 类型配置
        series: [
          {
            name: '安全分值',
            // 类型配置
            type: 'bar',
            barWidth: '40%',
            // 数据配置
            data: seriesData,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  fontSize: 14,
                  position: 'insideTop',
                  formatter: '{c}'
                }
              }
            }
          },
          {
            name: '危险设备占比',
            // // 类型配置
            type: 'line',
            yAxisIndex: 1,
            // 数据配置
            data: seriesList,
            // tooltip: {
            //   valueFormatter: function (value) {
            //     return value + ' °%'
            //   }
            // },
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  fontSize: 14,
                  color: '#667eea',
                  position: 'right',
                  formatter: '{c}'
                }
              }
            }
          }
        ]
      }
      mychart.setOption(option, true)
      // window.addEventListener('resize', this.resize)
    }
  }
}
</script>
